import React from 'react';

const AuthLayout = (props) => {
    return (
        <div id="lumisoftauthentication">
            {props.children}
        </div>
    );
}

export default AuthLayout;